import { render, staticRenderFns } from "./ApiLookupAuthFormSection.vue?vue&type=template&id=7b820443&scoped=true&"
import script from "./ApiLookupAuthFormSection.vue?vue&type=script&lang=js&"
export * from "./ApiLookupAuthFormSection.vue?vue&type=script&lang=js&"
import style0 from "./ApiLookupAuthFormSection.vue?vue&type=style&index=0&id=7b820443&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b820443",
  null
  
)

export default component.exports